export function syncSchedulePanelRowHeights(
  leftPanel: Element | null | undefined,
  centerPanel: Element | null | undefined,
  rightPanel?: Element | null | undefined,
  minRowHeight = 44
): void {
  if (!leftPanel || !centerPanel) {
    return;
  }

  const leftRows = Array.from(
    leftPanel.querySelectorAll<HTMLElement>(':scope > .schedule-row')
  );
  const centerRows = Array.from(
    centerPanel.querySelectorAll<HTMLElement>(':scope > .schedule-row')
  );
  const rightRows = rightPanel
    ? Array.from(rightPanel.querySelectorAll<HTMLElement>(':scope > .schedule-row'))
    : [];
  const count = Math.max(leftRows.length, centerRows.length, rightRows.length);

  for (let i = 0; i < count; i += 1) {
    const rows = [leftRows[i], centerRows[i], rightRows[i]].filter(Boolean) as HTMLElement[];
    rows.forEach((row) => {
      row.style.height = '';
      row.style.minHeight = '';
    });
  }

  for (let i = 0; i < count; i += 1) {
    const rows = [leftRows[i], centerRows[i], rightRows[i]].filter(Boolean) as HTMLElement[];
    if (rows.length === 0) {
      continue;
    }

    const naturalMax = Math.max(
      ...rows.map((row) => row.getBoundingClientRect().height)
    );

    if (naturalMax <= minRowHeight + 1) {
      rows.forEach((row) => {
        row.style.height = '';
        row.style.minHeight = `${minRowHeight}px`;
      });
      continue;
    }

    const heightPx = `${Math.ceil(naturalMax)}px`;
    rows.forEach((row) => {
      row.style.height = heightPx;
      row.style.minHeight = heightPx;
    });
  }
}

export function observeSchedulePanelRowHeights(
  leftPanel: Element | null | undefined,
  centerPanel: Element | null | undefined,
  rightPanel?: Element | null | undefined,
  minRowHeight = 44
): () => void {
  if (!leftPanel || !centerPanel) {
    return () => {};
  }

  let rafId = 0;
  const scheduleSync = () => {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      syncSchedulePanelRowHeights(leftPanel, centerPanel, rightPanel, minRowHeight);
    });
  };

  const observer = new ResizeObserver(scheduleSync);
  observer.observe(leftPanel);
  observer.observe(centerPanel);
  if (rightPanel) {
    observer.observe(rightPanel);
  }
  leftPanel.querySelectorAll('.schedule-row').forEach((row) => observer.observe(row));

  scheduleSync();

  return () => {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    observer.disconnect();
  };
}
